import { DJProfile } from '../../../lib/supabase';

interface SocialMediaProps {
  profile: DJProfile | null;
}

export default function SocialMedia({ profile }: SocialMediaProps) {
  const sectionTitle = profile?.section_social_title || 'Sígueme en Redes';
  const sectionDescription = profile?.section_social_description || 'Mantente al día con mis últimas sesiones y lanzamientos';

  const socialLinks = [
    { name: 'Spotify', icon: 'ri-spotify-fill', url: profile?.spotify, color: '#1DB954', visible: profile?.spotify_visible !== false },
    { name: 'SoundCloud', icon: 'ri-soundcloud-fill', url: profile?.soundcloud, color: '#FF5500', visible: profile?.soundcloud_visible !== false },
    { name: 'Instagram', icon: 'ri-instagram-fill', url: profile?.instagram, color: '#E4405F', visible: profile?.instagram_visible !== false },
    { name: 'YouTube', icon: 'ri-youtube-fill', url: profile?.youtube, color: '#FF0000', visible: profile?.youtube_visible !== false },
    { name: 'Facebook', icon: 'ri-facebook-fill', url: profile?.facebook, color: '#1877F2', visible: profile?.facebook_visible !== false },
    { name: 'TikTok', icon: 'ri-tiktok-fill', url: profile?.tiktok, color: '#000000', visible: profile?.tiktok_visible !== false },
    { name: 'Twitter', icon: 'ri-twitter-x-fill', url: profile?.twitter, color: '#000000', visible: profile?.twitter_visible !== false },
  ].filter(link => link.url && link.visible);

  return (
    <section className="py-20 bg-gradient-to-b from-black via-black to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/5 via-transparent to-fuchsia-500/5"></div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-black mb-4 flex flex-wrap justify-center gap-x-3">
            <span className="bg-gradient-to-r from-cyan-400 to-cyan-300 bg-clip-text text-transparent drop-shadow-[0_0_12px_rgba(34,211,238,0.6)]">Sígueme</span>
            <span className="text-white">en</span>
            <span className="bg-gradient-to-r from-fuchsia-400 to-pink-400 bg-clip-text text-transparent drop-shadow-[0_0_12px_rgba(232,121,249,0.6)]">Redes</span>
          </h2>
          <p className="text-gray-400 text-lg">
            {sectionDescription}
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 lg:gap-12">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative w-18 h-18 flex items-center justify-center cursor-pointer"
              style={{ width: '72px', height: '72px' }}
            >
              <div 
                className="absolute inset-0 rounded-full bg-[#252525] group-hover:bg-opacity-0 transition-all duration-300"
                style={{
                  backgroundColor: '#252525'
                }}
              ></div>
              <div 
                className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 shadow-lg"
                style={{
                  backgroundColor: social.color,
                  boxShadow: `0 0 30px ${social.color}80`
                }}
              ></div>
              <i 
                className={`${social.icon} text-white text-3xl relative z-10 group-hover:scale-110 transition-transform duration-300`}
              ></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
